import { AssignedAvailableDriverResponse, toAvailableDriverOption } from './available-driver';

interface IDriver {
	userId: number;
	driverTruckId: number;
	fullName: string;
	truckId: number | null;
	truckName: string | null;
	branchId: number | null;
	branchName: string | null;
}

export class Driver implements IDriver {
	userId: number;
	driverTruckId: number;
	fullName: string;
	truckId: number | null;
	truckName: string | null;
	branchId: number | null;
	branchName: string | null;

	constructor(data: AssignedAvailableDriverResponse) {
		// DOVE-2298 — shared mapper so this model and the dropdown mappers agree on how a truckless
		// 3rd-party assignment collapses (no truck, and therefore no truck-derived branch object).
		// `branch_name` used to be read off the root of the payload, which the API resource has
		// never emitted, so branchName was silently undefined for every driver.
		const option = toAvailableDriverOption(data);

		this.userId = data.user_id;
		this.driverTruckId = option.driverTruckId;
		// Deliberately NOT option.label. The dropdowns label a driver with the API's `name`
		// (firstname + middlename + lastname), but the dispatcher board and the assigned-orders
		// driver picker have always rendered "firstname lastname"; that existing display format is
		// preserved here rather than quietly gaining middle names off the back of this fix.
		this.fullName = data.driver.firstname + ' ' + data.driver.lastname;
		this.truckId = option.truckId;
		this.truckName = option.truckName;
		this.branchId = option.branchId;
		this.branchName = option.branchName;
	}
}
